import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left.svg";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import IdentityInfo from "./IdentityInfo";
import { useAppSelector } from "../../../../../hooks/useRedux";
import BottomTabbar from "../../../../layout/DriverLayout/BottomTabbar";
import IdentityDocuments from "./IdentityDocuments";
import AccommodationInfo from "./AccommodationInfo";
import BankAccountInfo from "./BankAccountInfo";

export default function EditProfile() {
  const [hasScroll, setHasScroll] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={hasScroll} />

      <Box
        ref={divRef}
        sx={{
          overflowY: "auto",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          gap: "16px",
          paddingX: "8px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "secondary.light",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "6px",
              borderRadius: "8px",
            }}
          >
            <InfoCircle color={theme.palette.secondary.main} />
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "600",
                color: "secondary.main",
              }}
            >
              نکته:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "secondary.main",
            }}
          >
            اطلاعات هویتی شما با عکس مدارکی که ارسال می‌کنید باید یکی باشد، در
            صورت هرگونه متغایرت، احراز هویت شما کامل نمی‌شود.
          </Typography>
        </Box>
        <IdentityInfo />
        <IdentityDocuments />
        <AccommodationInfo />
        <BankAccountInfo />
      </Box>
      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 600,
        }}
      >
        حساب کاربری من
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        ویرایش اطلاعات{" "}
      </Typography>
    </Box>
  );
}
